import { ErrorBoundary } from "react-error-boundary";
import ProjectRouter from "./Router";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function MyFallbackComponent({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

function logErrorToService(error: Error, info: any) {
  console.error("Caught an error:", error, info);
}
export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <ErrorBoundary
      FallbackComponent={MyFallbackComponent}
      onError={logErrorToService}
    >
      <ProjectRouter />
    </ErrorBoundary>
  );
}
